import React, { useState } from "react";
import { Navigation } from "swiper";
import { useDispatch } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import Header from "./Header";
// import Footer from "../Component/Footer/Footer";
import LoginForm from "./Forms/LoginForm";
import OtpForm from "./Forms/OtpForm";
import Registration from "./Forms/Registration";
import Success from "./Forms/Success";
import KidexContainer from "./Components/KidexContainer";
import StudentDevelopment from "./Components/StudentDevelopment";
import DevelopmentServices from "./Components/DevelopmentServices";
import SchoolList from "./Components/SchoolList";
import OurTeam from "./Components/OurTeam";
import bannerImg from "../../Assets/landing-page/banner-img.svg";
import schResImg from "../../Assets/landing-page/sch-res-1.svg";
import schResImg2 from "../../Assets/landing-page/sch-res-2.svg";
import schResImg3 from "../../Assets/landing-page/sch-res-3.svg";
import schResImg4 from "../../Assets/landing-page/sch-res-4.svg";
import schResImg5 from "../../Assets/landing-page/sch-res-5a.svg";
import orgRevCrd1 from "../../Assets/landing-page/org-img-1.svg";
import orgRevCrd2 from "../../Assets/landing-page/org-img-2.svg";
import orgRevCrd3 from "../../Assets/landing-page/org-img-3.svg";
import orgRevCrd4 from "../../Assets/landing-page/org-img-4.svg";
import awardRecgCrd1 from "../../Assets/landing-page/award-recg-1.svg";
import awardRecgCrd2 from "../../Assets/landing-page/award-recg-2.svg";
import awardRecgCrd3 from "../../Assets/landing-page/award-recg-3.svg";
import awardRecgCrd4 from "../../Assets/landing-page/award-recg-4.svg";
import awardRecgCrd5 from "../../Assets/landing-page/award-recg-5.svg";
import awardRecgCrd6 from "../../Assets/landing-page/award-recg-6.svg";
import awardRecgCrd7 from "../../Assets/landing-page/award-recg-7.svg";
import memorieImg1 from "../../Assets/landing-page/memorie-imgs/1.jpeg";
import memorieImg2 from "../../Assets/landing-page/memorie-imgs/2.jpeg";
import memorieImg3 from "../../Assets/landing-page/memorie-imgs/3.jpg";
import memorieImg4 from "../../Assets/landing-page/memorie-imgs/4.jpg";
import memorieImg5 from "../../Assets/landing-page/memorie-imgs/5.jpeg";
import memorieImg6 from "../../Assets/landing-page/memorie-imgs/6.jpeg";
import memorieImg7 from "../../Assets/landing-page/memorie-imgs/7.jpeg";
import memorieImg8 from "../../Assets/landing-page/memorie-imgs/8.jpeg";
import memorieImg9 from "../../Assets/landing-page/memorie-imgs/9.jpg";
import memorieImg10 from "../../Assets/landing-page/memorie-imgs/10.jpg";
import memorieImg11 from "../../Assets/landing-page/memorie-imgs/11.jpg";
import memorieImg12 from "../../Assets/landing-page/memorie-imgs/12.jpg";
import memorieImg13 from "../../Assets/landing-page/memorie-imgs/13.jpg";
import memorieImg14 from "../../Assets/landing-page/memorie-imgs/14.jpg";
import memorieImg21 from "../../Assets/landing-page/memorie-imgs/21.jpeg";
import { resetAuthentication } from "../../redux/actions/auth";
import "swiper/swiper.min.css";
import "./style.css";
import { AWES_LOGO, AWES_TAG_LINE } from "../../redux/actions/config";
import { isValidString } from "../../helper";
import { useLocation } from "react-router";
import Footer from "./Footer/Footer";

const Landing = (props) => {

   const dispatch = useDispatch();
   const location = useLocation();

   const data = props.history?.location?.state || {};
   const reg = new URLSearchParams(location?.search).get("register");

   const LoginComponents = {
      1: LoginForm,
      2: OtpForm
   }
   const RegisterComponent = {
      1: Registration,
      2: Success
   }

   const [register, setRegiter] = useState(reg);
   const [state, setState] = useState({
      step: 1,
      formData: {},
      ...data,
   });

   const handleForm = (state) => {
      dispatch(resetAuthentication());
      setState({
         step: 1,
         formData: {},
         ...data,
      });
      setRegiter(state);
   }

   const handleNavigation = ({ formData = {}, step = 0 } = {}) => {
      setState((prevState) => ({
         ...prevState,
         step: step || prevState?.step + 1,
         formData: { ...formData }
      }));
   };
   const Comp = register ? RegisterComponent[state.step] : LoginComponents[state.step];

   return (
      <React.Fragment>
         <div className="landing-page" id="landing-page">
            <div className="main-header">
               <Header />
            </div>
            <section className="landing-banner">
               <div className="container-fluid">
                  <div className="row m-0">
                     <div className="banner-portal-sec col-md-12 col-lg-8 col-xl-8 ">
                        <div className="bnnr-portal col-md-10 col-lg-9 ">
                           <p className="portal-heading">{AWES_TAG_LINE}</p>
                           <p className="portal-sub-heading">
                              For School Mangement & Teachers
                           </p>
                           <h1 className="landing-title">
                              Login to check your students’ holistic progress card
                              created basis participation & performance across KidEx
                              platform hosted competitions, quizzes & Experiential Learning
                              activities.
                           </h1>
                           <div className="responsive-btn">
                              <button
                                 className="btn purple-button"
                                 data-bs-toggle="modal"
                                 data-bs-target="#loginModal"
                                 onClick={() => handleForm(false)}
                              >
                                 Login
                              </button>
                              <button
                                 className="btn purple-outline-button"
                                 data-bs-toggle="modal"
                                 data-bs-target="#loginModal"
                                 onClick={() => handleForm(true)}
                              >
                                 Create account
                              </button>
                           </div>
                        </div>
                        {isValidString(AWES_LOGO) &&
                           <div className="text-center py-2">
                              <img src={AWES_LOGO} width="150" alt="loading..." />
                           </div>
                        }
                        <div className="banner-img">
                           <img src={bannerImg} alt="banner" />
                        </div>
                     </div>
                     <div className="banner-form-sec col-md-12 col-lg-4 col-xl-4 ">
                        <Comp onComplete={handleNavigation} data={state?.formData} toggleForm={handleForm} />
                     </div>
                  </div>
               </div>
            </section>
            <div
               className="modal fade"
               id="loginModal"
               tabIndex="-1"
               aria-labelledby="exampleModalLabel"
               aria-hidden="true"
            >
               <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                     <span type="button" className="btn-close modal-close-btn" data-bs-dismiss="modal" aria-label="Close"></span>
                     <Comp onComplete={handleNavigation} data={state?.formData} toggleForm={handleForm} />
                  </div>
               </div>
            </div>
            <section className="school-responsible-sec outer-space">
               <div className="sec-main-heading">
                  Schools responsible to ensure <br /> Holistic Development of all
                  Students
               </div>
               <div className="school-resnbl-card-outer">
                  <KidexContainer>
                     <div className="school-responsible-cards col-md-10 mx-auto">
                        <div className="row no-margin">
                           <div className="school-resnbl-card no-padding col-6">
                              <img src={schResImg} />
                           </div>
                           <div className="school-resnbl-card no-padding col-6">
                              <img src={schResImg2} />
                           </div>
                           <div className="school-resnbl-card no-padding col-6">
                              <img src={schResImg3} />
                           </div>
                           <div className="school-resnbl-card no-padding col-6">
                              <img src={schResImg4} />
                           </div>
                        </div>
                        <div className="school-resnbl-footer">
                           <p>
                              Best schools offer maximum <br />
                              Beyond Academics Experiential Learning Program
                           </p>
                        </div>
                     </div>
                  </KidexContainer>
               </div>
               <div className="school-resnbl-card-outer">
                  <KidexContainer>
                     <div className="school-responsible-cards col-md-10 mx-auto">
                        <div className="row no-margin">
                           <div className="school-resnbl-card school-resnbl-card-second  no-padding col-12 col-md-5 col-xl-5">
                              <img src={schResImg5} />
                           </div>
                           <div className="no-padding col-12 col-md-7 col-xl-7">
                              <div className="school-resnbl-text-card card">
                                 <p className="sch-resnbl-crd-hdng">Section 4</p>
                                 <p>
                                    Learning should be Holistic, Integrated, Enjoyable and
                                    Engaging
                                 </p>
                              </div>
                              <div className="school-resnbl-text-card card">
                                 <p className="sch-resnbl-crd-hdng">Section 4.35</p>
                                 <p>
                                    The progress card of all students … will be completely
                                    redesigned .. SCERTS. The progress card will be a
                                    holistic, 360-degree, multidimensional report that
                                    reflects in great details the progress as well as the
                                    uniqueness of each learner in the cognitive, affective,
                                    and psychomotor domains. It will include self-assessment
                                    and peer assessment, and progress of the child … teacher
                                    assessment.
                                 </p>
                              </div>
                              <div className="school-resnbl-text-card card">
                                 <p className="sch-resnbl-crd-hdng">Section 4.46</p>
                                 <p>
                                    Once ...online apps with quizzes, competitions,
                                    assessments, enrichment materials, and online communities
                                    for shared interests will be developed, and will work to
                                    enhance all the aforementioned initiatives, as group
                                    activities for students with appropriate supervision of
                                    parents and teachers.
                                 </p>
                              </div>
                           </div>
                        </div>
                        <div className="school-resnbl-footer">
                           <p>
                              National Education Policy 2020 (NEP 2020) <br /> regularizing
                              Holistic Development as Curriculum
                           </p>
                        </div>
                     </div>
                  </KidexContainer>
               </div>
            </section>
            <StudentDevelopment />
            <DevelopmentServices />
            <section className="detail-sec">
               <KidexContainer>
                  <p className="details-text no-margin">
                     For more details, write to us at{" "}
                     <a href="mailto:info@kid-ex.com">info@kid-ex.com</a> or
                     Call/Whatsapp at <a href="tel:8800201291">+91- 8800201291</a>.
                     <br /> Our team will assist you at the earliest.
                  </p>
               </KidexContainer>
            </section>
            <section className="organizations-review-sec outer-space">
               <div className="sec-main-heading">
                  Trusted & used by Parents, Schools,
                  <br /> Government & Private Organizations
               </div>
               <KidexContainer>
                  <div className="organizations-review-cards">
                     <div className="org-rew-card text-center">
                        <div className="org-rew-card-img">
                           <img src={orgRevCrd1} />
                        </div>
                        <div className="orgrew-card-review">
                           <p>3L+</p>
                           <span>Young Leaders served</span>
                        </div>
                     </div>
                     <div className="org-rew-card text-center">
                        <div className="org-rew-card-img">
                           <img src={orgRevCrd2} />
                        </div>
                        <div className="orgrew-card-review">
                           <p>3,000+</p>
                           <span>Leading schools served</span>
                        </div>
                     </div>
                     <div className="org-rew-card text-center">
                        <div className="org-rew-card-img">
                           <img src={orgRevCrd3} />
                        </div>
                        <div className="orgrew-card-review">
                           <span>Multiple Government partnerships</span>
                        </div>
                     </div>
                     <div className="org-rew-card text-center">
                        <div className="org-rew-card-img">
                           <img src={orgRevCrd4} />
                        </div>
                        <div className="orgrew-card-review">
                           <span>
                              Multiple Private <br /> partnerships
                           </span>
                        </div>
                     </div>
                  </div>
               </KidexContainer>
            </section>
            <SchoolList />
            <section className="award-recognation-sec outer-space">
               <div className="sec-main-heading">Our key Awards & Recognitions</div>
               <KidexContainer>
                  <div className="award-recognation-cards">
                     <div className="award-recog-card">
                        <img src={awardRecgCrd1} />
                     </div>
                     <div className="award-recog-card">
                        <img src={awardRecgCrd2} />
                     </div>
                     <div className="award-recog-card">
                        <img src={awardRecgCrd3} />
                     </div>
                     <div className="award-recog-card">
                        <img src={awardRecgCrd4} />
                     </div>
                     <div className="award-recog-card">
                        <img src={awardRecgCrd5} />
                     </div>
                     <div className="award-recog-card">
                        <img src={awardRecgCrd6} />
                     </div>
                     <div className="award-recog-card">
                        <img src={awardRecgCrd7} />
                     </div>
                  </div>
               </KidexContainer>
            </section>
            <OurTeam />
            <section className="leadership-sec post-crousel outer-space">
               <div className="sec-main-heading no-margin">
                  Select memories from our journey till date
               </div>
               <KidexContainer>
                  <div className="memories-crousel swiper_wrap">
                     <Swiper
                        navigation={{
                           nextEl: '.next-memories-swiper',
                           prevEl: '.prev-memories-swiper',
                        }}
                        modules={[Navigation]}
                        spaceBetween={0}
                        // slidesPerView={3.5}
                        loop={true}
                        breakpoints={{
                           320: {
                              spaceBetween: 8,
                              slidesPerView: 1,
                              loop: true
                           },
                           460: {
                              spaceBetween: 10,
                              slidesPerView: 1.2,
                              loop: true
                           },
                           480: {
                              spaceBetween: 10,
                              slidesPerView: 1.2,
                              loop: true
                           },
                           576: {
                              spaceBetween: 8,
                              slidesPerView: 2.2,
                              loop: true
                           },
                           768: {
                              spaceBetween: 8,
                              slidesPerView: 2.5,
                              loop: true
                           },
                           820: {
                              spaceBetween: 8,
                              slidesPerView: 3.5,
                              loop: true
                           },
                           960: {
                              spaceBetween: 8,
                              slidesPerView: 3.5,
                              loop: true
                           },
                        }}
                     >
                        <SwiperSlide className="post-crousel-crd-outer">
                           <div className="post-crosl-card">
                              <div className="post-crosl-card-img">
                                 <img src={memorieImg1} />
                              </div>
                              <p className="memorie-card-title">
                                 Our founders with Sh. Amitabh Kant,<br /> CEO, NITI Aayog
                              </p>
                           </div>
                        </SwiperSlide>
                        <SwiperSlide className="post-crousel-crd-outer">
                           <div className="post-crosl-card">
                              <div className="post-crosl-card-img">
                                 <img src={memorieImg2} />
                              </div>
                              <p className="memorie-card-title">
                                 Our founders with Sh. Gautam Gambhir
                              </p>
                           </div>
                        </SwiperSlide>
                        <SwiperSlide className="post-crousel-crd-outer">
                           <div className="post-crosl-card">
                              <div className="post-crosl-card-img">
                                 <img src={memorieImg3} />
                              </div>
                              <p className="memorie-card-title">
                                 Our team with Sh. Sandeep Singh Ji,<br />  UP Government
                              </p>
                           </div>
                        </SwiperSlide>
                        <SwiperSlide className="post-crousel-crd-outer">
                           <div className="post-crosl-card">
                              <div className="post-crosl-card-img">
                                 <img src={memorieImg4} />
                              </div>
                              <p className="memorie-card-title">
                                 Our team with Sh. Deepak Kesarkar Ji,<br />  MH Government
                              </p>
                           </div>
                        </SwiperSlide>
                        <SwiperSlide className="post-crousel-crd-outer">
                           <div className="post-crosl-card">
                              <div className="post-crosl-card-img">
                                 <img src={memorieImg5} />
                              </div>
                              <p className="memorie-card-title">
                                 Our core team with Shmt. Sarabjit Kaur Dhillon, Mayor of Chandigarh
                              </p>
                           </div>
                        </SwiperSlide>
                        <SwiperSlide className="post-crousel-crd-outer">
                           <div className="post-crosl-card">
                              <div className="post-crosl-card-img">
                                 <img src={memorieImg6} />
                              </div>
                              <p className="memorie-card-title">
                                 Our founder with Dr. Biswajit Saha, CBSE
                              </p>
                           </div>
                        </SwiperSlide>
                        <SwiperSlide className="post-crousel-crd-outer">
                           <div className="post-crosl-card">
                              <div className="post-crosl-card-img">
                                 <img src={memorieImg7} />
                              </div>
                              <p className="memorie-card-title">
                                 Our core team with Sh. R P Singh, CBSE
                              </p>
                           </div>
                        </SwiperSlide>
                        <SwiperSlide className="post-crousel-crd-outer">
                           <div className="post-crosl-card">
                              <div className="post-crosl-card-img">
                                 <img src={memorieImg8} />
                              </div>
                              <p className="memorie-card-title">
                                 Our founder addressing School<br />  Principals in Pune
                              </p>
                           </div>
                        </SwiperSlide>
                        <SwiperSlide className="post-crousel-crd-outer">
                           <div className="post-crosl-card">
                              <div className="post-crosl-card-img">
                                 <img src={memorieImg9} />
                              </div>
                              <p className="memorie-card-title">
                                 Our founder addressing School <br />  Principals in Bengaluru
                              </p>
                           </div>
                        </SwiperSlide>
                        <SwiperSlide className="post-crousel-crd-outer">
                           <div className="post-crosl-card">
                              <div className="post-crosl-card-img">
                                 <img src={memorieImg10} />
                              </div>
                              <p className="memorie-card-title">
                                 Our founder addressing School <br />  Principals in Mumbai
                              </p>
                           </div>
                        </SwiperSlide>
                        <SwiperSlide className="post-crousel-crd-outer">
                           <div className="post-crosl-card">
                              <div className="post-crosl-card-img">
                                 <img src={memorieImg11} />
                              </div>
                              <p className="memorie-card-title">
                                 Our core team addressing School <br /> Principals in Chandigarh
                              </p>
                           </div>
                        </SwiperSlide>
                        <SwiperSlide className="post-crousel-crd-outer">
                           <div className="post-crosl-card">
                              <div className="post-crosl-card-img">
                                 <img src={memorieImg12} />
                              </div>
                              <p className="memorie-card-title">
                                 Our founder addressing School <br />  Principals in Lucknow
                              </p>
                           </div>
                        </SwiperSlide>
                        <SwiperSlide className="post-crousel-crd-outer">
                           <div className="post-crosl-card">
                              <div className="post-crosl-card-img">
                                 <img src={memorieImg13} />
                              </div>
                              <p className="memorie-card-title">
                                 Our founder with Principal,<br />  Birla Vidya Niketan
                              </p>
                           </div>
                        </SwiperSlide>
                        <SwiperSlide className="post-crousel-crd-outer">
                           <div className="post-crosl-card">
                              <div className="post-crosl-card-img">
                                 <img src={memorieImg14} />
                              </div>
                              <p className="memorie-card-title">
                                 Our founder with Principal,<br />  Amity International School, Noida
                              </p>
                           </div>
                        </SwiperSlide>
                        <SwiperSlide className="post-crousel-crd-outer">
                           <div className="post-crosl-card">
                              <div className="post-crosl-card-img">
                                 <img src={memorieImg21} />
                              </div>
                              <p className="memorie-card-title">
                                 Google Play leadership team at our office
                              </p>
                           </div>
                        </SwiperSlide>
                     </Swiper>
                     <div className="swiper-button-prev prev-memories-swiper"></div>
                     <div className="swiper-button-next next-memories-swiper"></div>
                  </div>
               </KidexContainer>
            </section>
            <Footer />
         </div>
      </React.Fragment>
   );
};
export default Landing;
